// extracted by mini-css-extract-plugin
export default {"name":"Input_name__ZGBZc","input":"Input_input__E5rzA","box":"Input_box__XUS71"};